import { type PropsWithChildren } from 'react';

import { useGridPlotSize } from '../../core/components/chart-grid/hooks/useGridPlotSize.js';
import { buildScale } from '../../core/utils/core-scale.js';
import { HistogramYScales } from '../contexts/HistogramYScales.context.js';
import { useHistogramFilteredData } from '../hooks/useHistogramFilteredData.js';
import { useYAxisConfig } from '../hooks/useYAxisConfig.js';

export const HistogramYScalesProvider = ({ children }: PropsWithChildren) => {
  const { minMaxPerUnit, units } = useHistogramFilteredData();
  const { height } = useGridPlotSize();
  const { left: leftYAxis, right: rightYAxis } = useYAxisConfig();

  const yScales = units.map((unit, i) => {
    if (i === 0) {
      const leftMinMaxValue = minMaxPerUnit.get(unit) ?? { min: 0, max: 0 };

      return buildScale(
        leftYAxis?.scale ?? 'linear',
        [height, 0],
        leftMinMaxValue,
        { min: leftYAxis?.min, max: leftYAxis?.max },
      );
    } else if (i === 1) {
      const rightMinMaxValue = minMaxPerUnit.get(unit) ?? { min: 0, max: 0 };

      return buildScale(
        rightYAxis?.scale ?? 'linear',
        [height, 0],
        rightMinMaxValue,
        { min: rightYAxis?.min, max: rightYAxis?.max },
      );
    } else {
      const minMaxValue = minMaxPerUnit.get(unit) ?? { min: 0, max: 0 };

      return buildScale('linear', [height, 0], minMaxValue);
    }
  });

  return (
    <HistogramYScales.Provider value={yScales}>
      {children}
    </HistogramYScales.Provider>
  );
};

HistogramYScalesProvider['displayName'] = 'HistogramYScalesProvider';
